import { NgModule } from '@angular/core';
import { PBreadcrumbsHeaderComponent } from './p-breadcrumbs-header.component';
import { PIconModule } from '@panaya/ui/p-icon';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [PBreadcrumbsHeaderComponent],
    imports: [CommonModule, RouterModule, PIconModule, MatTooltipModule],
    exports: [PBreadcrumbsHeaderComponent]
})
export class PBreadcrumbsHeaderModule {}
